import React from 'react';
import { alpha, Box, Button, IconButton, Stack, SvgIcon, SxProps, Typography } from '@mui/material';
import { palette, spaces } from '../../../assets/styles/themes/tokens';
import { colors } from '../../../assets/styles/themes/variables';
import getMuiIcon from '../../../utils/getMuiIcon';
import { IconName } from '../../../utils/getMuiIcon';
import useScreenSize from '../../../utils/useScreenSize';
import { useTranslation } from 'react-i18next';

interface ArrowNavigationButtonProps {
  dataTestId: string;
  iconName: IconName;
  onClick: () => void;
  sxProps?: SxProps;
}

interface CarouselHeaderProps {
  title: string;
  onSlideNext: () => void;
  onSlidePrev: () => void;
  onShowAll: () => void;
}

const ArrowNavigationButton: React.FC<ArrowNavigationButtonProps> = (props) => {
  const { iconName, sxProps, onClick, dataTestId } = props;
  return (
    <IconButton
      data-testid={dataTestId}
      color='secondary'
      size='small'
      onClick={onClick}
    >
      <SvgIcon 
        sx={{ 
          width: 20,
          height: 20,
          color: palette.action.active,
          ...sxProps,
        }}
        component={getMuiIcon(iconName)} 
      />
    </IconButton>
  );
};

const CarouselHeader: React.FC<CarouselHeaderProps> = (props) => {
  const { t } = useTranslation();
  const { isLargeScreen, isMediumScreen } = useScreenSize();
  const { title, onSlideNext, onSlidePrev, onShowAll } = props;
  
  return (
    <Box
      data-testid='carousel-header'
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingY: spaces.sm,
        gap: spaces.xs,
      }}
    >
      <Typography variant='h6' color={palette.text.primary}>{title}</Typography>
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: spaces.xs }}>
        <Button
          variant='outlined'
          color='primary'
          size='small'
          onClick={onShowAll}
          sx={{
            borderColor: alpha(colors.blue700, 0.48),     
          }}
        >
          {t('Show all')}
        </Button>
        {(isMediumScreen || isLargeScreen) && (
          <Stack direction='row' alignItems='center' justifyContent='space-between' gap={spaces.xs}>
            <ArrowNavigationButton
              dataTestId='arrow-navigation-button-left' 
              iconName='arrowLeft'
              onClick={onSlidePrev} 
            />
            <ArrowNavigationButton
              dataTestId='arrow-navigation-button-right'  
              iconName='arrowLeft'
              sxProps={{ transform: 'rotate(180deg)' }}
              onClick={onSlideNext} 
            />
          </Stack>
        )}
      </Box>
    </Box>
  );
};

export default CarouselHeader;
